import { dt, DT } from './util/dateTime';

export const INVITE_EXPIRATION_DAYS = 5;

export const getCanResendInvite = (expiresAt: DT) => {
    return hoursSinceInvitationSent(expiresAt) >= 1;
};

const hoursSinceInvitationSent = (expiresAt: DT) => {
    // We use expiresAt as a proxy for this, since it's set to 5 days after the invitation is sent
    const invitationSentAt = dt(expiresAt).subtract(
        INVITE_EXPIRATION_DAYS,
        'days'
    );
    return dt().diff(invitationSentAt, 'hours');
};
